/**
 * Mirrors RotatingText(splitBy="characters"): spaces become layout gaps,
 * not `.text-rotate-element` nodes. GSAP setup must count the same way.
 */
export function splitRotatingTextCharacters(text) {
  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    return Array.from(
      new Intl.Segmenter("en", { granularity: "grapheme" }).segment(text),
      (segment) => segment.segment,
    );
  }

  return Array.from(text);
}

export function countRotatingTextElements(text) {
  return String(text)
    .split(" ")
    .reduce((count, word) => count + splitRotatingTextCharacters(word).length, 0);
}
